import React, { useEffect } from 'react';
import { loadScript, redirectToPaymentFailurePage, redirectToOrderProcessingPage } from 'common/utilities/utils';
import { dgftApplePayGenerateToken, dgftAuthorizePayment } from '@kfc-global/react-shared/redux/Actions/PaymentsAction';
import { PAYMENT_TENDER_TYPES } from 'common/constants/SharedConstants';
import PAYMENT_CONSTANTS from 'organisms/Payment/constants/PaymentConstants';
import { config } from '@kfc-global/react-shared/config/config.utils';
import { DGFT_APPLE_PAY_SDK_URL } from '@kfc-global/react-shared/config/config.constants';

const dgftApplePayGenerateTokenAction = (event, session, dispatch) => {
  dispatch(
    dgftApplePayGenerateToken(
      {
        validationurl: { validationURL: event.validationURL },
      },
      merchantSession => {
        session.completeMerchantValidation(merchantSession);
      },
      error => {
        console.error(error, 'errorCallback');
        session.abort();
      },
    ),
  );
};

const dgftAuthorizePaymentAction = ({ event, session, dispatch, checkoutDetails, props }) => {
  dispatch(
    dgftAuthorizePayment(
      {
        paymentType: PAYMENT_TENDER_TYPES?.APPLE_PAY,
        data: {
          paymentreferencenumber: checkoutDetails?.DgftPaymentId,
          tenderType: checkoutDetails?.tender?.name,
          orderId: checkoutDetails?.orderId,
          amount: checkoutDetails?.finalAmount,
          transactionId: checkoutDetails?.DgftTransactionId,
          paymentData: JSON.stringify(event.payment.token.paymentData),
        },
      },
      param => {
        session.completePayment(PAYMENT_CONSTANTS?.DGFT_APPLE_PAY_CONSTANTS?.STATUS_SUCCESS);
        redirectToOrderProcessingPage(props);
      },
      error => {
        session.completePayment(PAYMENT_CONSTANTS?.DGFT_APPLE_PAY_CONSTANTS?.STATUS_FAILURE);
        redirectToPaymentFailurePage(props);
        session.abort();
      },
    ),
  );
};

const DgftApplepay = props => {
  const { checkoutDetails } = props;
  const { dispatch } = checkoutDetails;
  const { DGFT_APPLE_PAY_CONSTANTS } = PAYMENT_CONSTANTS;

  const onApplePayButtonClicked = () => {
    if (!window?.ApplePaySession?.canMakePayments()) {
      console.log('Not capable browser');
      return;
    }

    const request = {
      countryCode: checkoutDetails?.countryCode,
      currencyCode: checkoutDetails?.currencyCode,
      supportedNetworks: DGFT_APPLE_PAY_CONSTANTS?.ALLOWED_CARD_NETWORKS,
      merchantCapabilities: DGFT_APPLE_PAY_CONSTANTS?.MERCHANT_CAPABILITIES,
      total: { label: DGFT_APPLE_PAY_CONSTANTS?.APPLEPAY, amount: checkoutDetails?.finalAmount?.toString() },
    };
    const session = new window.ApplePaySession(DGFT_APPLE_PAY_CONSTANTS?.APPLE_PAY_VERSION_NUMBER, request);
    session.onvalidatemerchant = event => dgftApplePayGenerateTokenAction(event, session, dispatch);

    session.onpaymentauthorized = event =>
      dgftAuthorizePaymentAction({ event, session, dispatch, checkoutDetails, props });

    session.begin();
  };

  useEffect(() => {
    loadScript(config(DGFT_APPLE_PAY_SDK_URL));
  }, []);

  return (
    <>
      <div
        style={{
          display: 'inline-block',
          '-webkit-appearance': '-apple-pay-button',
          '-apple-pay-button-type': 'buy',
          '-apple-pay-button-style': 'black',
        }}
        onClick={onApplePayButtonClicked}
        id='dgftapplepayButton'
        data-testid='dgft-apple-pay'
        className='apple-pay'
      ></div>
    </>
  );
};

export default DgftApplepay;
